<template>
  <el-dialog
      :close-on-click-modal="false"
    title="审核结果"
    append-to-body
    :visible.sync="dialogpassVisible"
    width="30%"
    
    :before-close="handleClose"
  >
  <div class="block">
  <el-timeline reverse="true">
    <el-timeline-item :timestamp=" item.createtime " placement="top" v-for="(item, index) in data.auditLog" :key="index" >
      <el-card>
        <div> <span class='examineName'>{{ item.name }} </span> <span class="warningtext">{{ item.deptName }}</span> </div>
        <div class='examinereson'>
          <div> 审核{{ item.pass == true ? "通过" : "退回" }}</div> 
           <div class='advice_div'>
            <div class='resons'>原因：</div> <div>{{ item.advice }}</div></div></div>
      </el-card>
    </el-timeline-item>
 
   
  </el-timeline>
</div>
  
  </el-dialog>
</template>

<script>
export default {
  name: "Dialog",
  data() {
    return { dialogpassVisible: false };
  },
  props: {
    data: JSON
  },
  methods: {
    handleClose() {
      this.dialogpassVisible = false;
    },
    showblock() {
      this.dialogpassVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
  .block{
    height: 300px;
    overflow: auto;
  }
/deep/.el-dialog__body{
  padding:30px 25px 22px 25px
}
/deep/.el-card.is-always-shadow{
  box-shadow: 0 2px 12px 0 rgba(0,0,0 ,0.1);
}
/deep/.el-timeline-item{
  width:95%
}
/deep/.el-dialog{
  border-radius: 8px;
}
.examineName{
  font-size: 14px;
  font-weight: bolder;
}
.warningtext{
  margin-left: 10px;
}
.examinereson{
  display: flex;
  margin-top:10px;
  flex-direction: row;
  .advice_div{
    flex:3;
    display: flex;
    flex-direction: row;
   .resons{
     width:45px;
     
   }
  }
}
.advice_div{
  margin-left: 10px;
}
</style>
